// extracted by mini-css-extract-plugin
export var attachmentContainer = "_kd-0";
export var fileList = "_kd-2";
export var removeFileButton = "_kd-1";